import "./NewsletterModal.css";

function NewsletterModal({ onClose }) {
  return (
    <div className="newsletter-overlay">
      <div className="newsletter-modal">

        <button
          className="newsletter-close"
          onClick={onClose}
        >
          ×
        </button>

        <img
          src="/images/about.png"
          alt="2gs Like Gucci"
          className="newsletter-avatar"
        />

        <h2 className="newsletter-title">
          Newsletter
        </h2>

        <p className="newsletter-description">
          Enter your email to get the latest news
          from 2gs Like Gucci. Include your city
          for updates specific to your area.
        </p>

        <form className="newsletter-form">

          <input
            type="email"
            placeholder="Enter your email"
            className="newsletter-input"
          />

          <input
            type="text"
            placeholder="Enter your city (optional)"
            className="newsletter-input"
          />

          <button
            type="submit"
            className="newsletter-submit"
          >
            Subscribe
          </button>

        </form>

      </div>
    </div>
  );
}

export default NewsletterModal;